var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg-white"},[_c('router-view',{key:this.$store.state.sidebar.navigationClicked})],1),(_vm.showloading)?_c('div',{staticClass:"app-loading-overlay"},[_c('LoadingSpinner')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }